import { useState } from 'react';

const BurgerMenu = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => { setIsOpen(!isOpen); }

    return (
        <>
            <button className={`burger-menu-toggle ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className={`burger-menu ${isOpen ? 'open' : ''}`}>
                <div className="burger-menu-inner">
                    <div className="burger-menu-items" onClick={toggleMenu}>
                        {props.renderNavLinks()}
                    </div>
                    <a className="burger-menu-button" style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }} target="_blank" href="https://pfizer.almaconnect.com/" rel="noreferrer">Signup/Login</a>
                </div>
            </div>
        </>
    );
};

export default BurgerMenu;